import type { WizardOpenConfig } from './ltl.types';

// Wizard open/close — bridges the page ↔ drawer mount/unmount
export const LTL_OPEN_WIZARD = 'LTL_OPEN_WIZARD';
export const openLtlWizard = (config: WizardOpenConfig = { mode: 'new-quote' }) => ({
  type: LTL_OPEN_WIZARD,
  config,
});

export const LTL_CLOSE_WIZARD = 'LTL_CLOSE_WIZARD';
export const closeLtlWizard = () => ({
  type: LTL_CLOSE_WIZARD,
});

// Document download (grid-level operation)
export const LTL_DOWNLOAD_DOCUMENT_REQUEST = 'LTL_DOWNLOAD_DOCUMENT_REQUEST';
export const downloadDocumentRequest = (freightShipmentId: number, key: string, docType: string) => ({
  type: LTL_DOWNLOAD_DOCUMENT_REQUEST,
  freightShipmentId,
  key,
  docType,
});

export const LTL_DOWNLOAD_DOCUMENT_SUCCESS = 'LTL_DOWNLOAD_DOCUMENT_SUCCESS';
export const downloadDocumentSuccess = (document: unknown) => ({
  type: LTL_DOWNLOAD_DOCUMENT_SUCCESS,
  document,
});

export const LTL_DOWNLOAD_DOCUMENT_ERROR = 'LTL_DOWNLOAD_DOCUMENT_ERROR';
export const downloadDocumentError = (error: string) => ({
  type: LTL_DOWNLOAD_DOCUMENT_ERROR,
  error,
});

// Bulk document print (grid-level operation, one request for all selected shipments)
export const LTL_BULK_PRINT_DOCUMENTS_REQUEST = 'LTL_BULK_PRINT_DOCUMENTS_REQUEST';
export const bulkPrintFreightDocumentsRequest = (freightShipmentIds: number[], docType: string) => ({
  type: LTL_BULK_PRINT_DOCUMENTS_REQUEST,
  freightShipmentIds,
  docType,
});

export const LTL_BULK_PRINT_DOCUMENTS_SUCCESS = 'LTL_BULK_PRINT_DOCUMENTS_SUCCESS';
export const bulkPrintFreightDocumentsSuccess = (document: unknown) => ({
  type: LTL_BULK_PRINT_DOCUMENTS_SUCCESS,
  document,
});

export const LTL_BULK_PRINT_DOCUMENTS_ERROR = 'LTL_BULK_PRINT_DOCUMENTS_ERROR';
export const bulkPrintFreightDocumentsError = (error: string) => ({
  type: LTL_BULK_PRINT_DOCUMENTS_ERROR,
  error,
});

// Track Shipment (grid-level operation)
export const LTL_TRACK_SHIPMENT_REQUEST = 'LTL_TRACK_SHIPMENT_REQUEST';
export const trackShipmentRequest = (freightShipmentId: number) => ({
  type: LTL_TRACK_SHIPMENT_REQUEST,
  freightShipmentId,
});

export const LTL_TRACK_SHIPMENT_SUCCESS = 'LTL_TRACK_SHIPMENT_SUCCESS';
export const trackShipmentSuccess = (trackingInfo: unknown) => ({
  type: LTL_TRACK_SHIPMENT_SUCCESS,
  trackingInfo,
});

export const LTL_TRACK_SHIPMENT_ERROR = 'LTL_TRACK_SHIPMENT_ERROR';
export const trackShipmentError = (error: string) => ({
  type: LTL_TRACK_SHIPMENT_ERROR,
  error,
});

// Pusher-driven freight quote actions
export const LTL_FREIGHT_QUOTE_PUSHER_SUCCESS = 'LTL_FREIGHT_QUOTE_PUSHER_SUCCESS';
export const freightQuoteSuccess = (messageGuid: string, data: unknown) => ({
  type: LTL_FREIGHT_QUOTE_PUSHER_SUCCESS,
  messageGuid,
  data,
});

export const LTL_FREIGHT_QUOTE_PUSHER_ERROR = 'LTL_FREIGHT_QUOTE_PUSHER_ERROR';
export const freightQuoteError = (messageGuid: string, errorMessage: string) => ({
  type: LTL_FREIGHT_QUOTE_PUSHER_ERROR,
  messageGuid,
  errorMessage,
});

// Pusher-driven freight book actions
export const LTL_FREIGHT_BOOK_PUSHER_SUCCESS = 'LTL_FREIGHT_BOOK_PUSHER_SUCCESS';
export const freightBookSuccess = (messageGuid: string, data: unknown) => ({
  type: LTL_FREIGHT_BOOK_PUSHER_SUCCESS,
  messageGuid,
  data,
});

export const LTL_FREIGHT_BOOK_PUSHER_ERROR = 'LTL_FREIGHT_BOOK_PUSHER_ERROR';
export const freightBookError = (messageGuid: string, errorMessage: string) => ({
  type: LTL_FREIGHT_BOOK_PUSHER_ERROR,
  messageGuid,
  errorMessage,
});

// Fulfillment type toggle
export const SET_FULFILLMENT_TYPE_FREIGHT = 'SET_FULFILLMENT_TYPE_FREIGHT';
export const setFulfillmentTypeFreight = (fulfillmentPlanId: string) => ({
  type: SET_FULFILLMENT_TYPE_FREIGHT,
  fulfillmentPlanId,
});

export const SET_FULFILLMENT_TYPE_PARCEL = 'SET_FULFILLMENT_TYPE_PARCEL';
export const setFulfillmentTypeParcel = (fulfillmentPlanId: string) => ({
  type: SET_FULFILLMENT_TYPE_PARCEL,
  fulfillmentPlanId,
});

export const SET_FULFILLMENT_TYPE_SUCCESS = 'SET_FULFILLMENT_TYPE_SUCCESS';
export const setFulfillmentTypeSuccess = () => ({
  type: SET_FULFILLMENT_TYPE_SUCCESS,
});

export const SET_FULFILLMENT_TYPE_ERROR = 'SET_FULFILLMENT_TYPE_ERROR';
export const setFulfillmentTypeError = (error: string) => ({
  type: SET_FULFILLMENT_TYPE_ERROR,
  error,
});

// Re-export grid actions for backward compatibility
export { GET_FREIGHT_GRID_REQUEST, getFreightGridRequest } from './grid/ltl.grid.actions';
